document.addEventListener('DOMContentLoaded', function() {
    const quickBuyButton = document.querySelector('.product-quick-buy');
    const addToCartButton = document.querySelector('#AddToCart');
    const redirectButton = document.querySelector('.product-information .redirect-button');

    if (quickBuyButton && addToCartButton && redirectButton) {
        quickBuyButton.addEventListener('click', function() {
            // Trigger the Add to Cart button
            
            addToCartButton.click();
           if (!addToCartButton.disabled) {
            quickBuyButton.classList.add('prevent-button'); 
            // After a slight delay, trigger the redirect button
            setTimeout(function() {
                redirectButton.click();
            }, 100); // Adjust the delay as needed
          } else {
             quickBuyButton.classList.remove('prevent-button'); 
          }
        });
    } else {
        console.error('One or more elements could not be found in the DOM.');
    }
});